import React, { useState, Fragment, useEffect } from 'react';
import { Button, Popover, Typography, Divider, Menu, MenuItem, Dialog, DialogContent, TextField, IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getRecurringPaymentInfo, recurringPaymentRequestAgent, cancelRecurringPayment } from '../../../../redux/actions/agentActions';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const styles = theme => ({
  btnAqua: {
    backgroundColor: '#00B2A9',
    color: '#FFFFFF',
    borderRadius: '14px',
    padding: '6px 16px 5px',
    fontFamily: 'Sura Sans, system-ui',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '14px',
    transition: 'all 0.4s ease-out',
    '&:hover': {
      backgroundColor: '#008295',
    }
  },
  menuButton: {
    marginLeft: '8px',
    padding: 0,
    height: '14px !important',
    width: '14px !important',
  },
  popover: {
    width: isMobile ? '100%' : '390px',
    height: '325px',
    backgroundColor: '#FFFFFF',
    border: '0px solid',
    borderRadius: '14px',
    padding: '20px 20px 15px',
    display: 'flex',
    flexDirection: 'column'
  },
  popoverTitle: {
    color: '#000000',
    fontSize: '18px',
    fontFamily: 'Sura Sans',
    textAlign: 'left',
    marginBottom: '20px'
  },
  popoverContent: {
    flex: 1,
    overflowY: 'auto',
    paddingTop: '20px'
  },
  popoverDivider: {
    color: '#707070',
  },
  popoverButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '16px',
    gap: '10px',
  },
  otherButton: {
    width: '152px',
    backgroundColor: '#ffffff',
    color: '#707070',
    border: '0px solid',
    borderRadius: '23px',
    padding: '6px 16px 5px',
    fontSize: '14px',
    fontFamily: 'Sura Sans',
    transition: 'all 0.4s ease-out',
    '&:hover': {
      backgroundColor: '#E8E8E8',
    }
  },
  acceptButton: {
    width: '152px',
    backgroundColor: '#ffffff',
    color: '#0033A0',
    border: '1px solid #0033A0',
    borderRadius: '23px',
    transition: 'all 0.4s ease-out',
    '&:hover': {
      backgroundColor: '#0033A0',
      color: '#ffffff',
    }
  },
  subPopover: {
    width: '226px',
    backgroundColor: '#FFFFFF',
    border: '0px solid',
    borderRadius: '14px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  subMenuItem: {
    width: '100%',
    backgroundColor: '#ffffff',
    color: '#707070',
    border: '0px solid',
    borderRadius: '23px',
    padding: '7px 5px',
    fontSize: '14px',
    fontFamily: 'Sura Sans',
    transition: 'all 0.4s ease-out',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#E8E8E8',
    }
  },
  cancelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 30px',
    gap: '16px',
  },
  modalTitle: {
    color: '#0033A0',
    fontSize: '22px',
    fontFamily: 'Sura Sans, system-ui',
    textAlign: 'center',
    marginBottom: '4px',
  },
  modalText: {
    color: '#0033A0',
    fontSize: '16px',
    fontFamily: 'Sura Sans, system-ui',
    textAlign: 'center',
  },
  policyNumber: {
    color: '#0033A0',
    fontSize: '16px',
    fontFamily: 'Sura Sans, system-ui',
    fontWeight: 'bold',
  },
  cancelReason: {
    width: '100%',
    height: '90px !important',
    minHeight: '90px',
    backgroundColor: '#f8f8f8',
    border: '0px solid',
    borderRadius: '15px',
    padding: '10px',
    resize: 'none',
    fontFamily: 'Sura Sans, system-ui',
    fontSize: '14px',
    '&::placeholder': {
      color: '#888b8d',
    },
    '&:focus': {
      outline: 'none'
    }
  },
  warningContainer: {
    width: '100%',
    height: '90px',
    minHeight: '90px',
    backgroundColor: '#e0eaff',
    border: '0px solid',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    gap: '10px',
  },
  warningText: {
    color: '#0033A0',
    fontSize: '14px',
    fontFamily: 'Sura Sans, system-ui',
  },
  warningIcon: {
    width: '40px',
    height: '40px'
  },
  cardInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#0033A0',
    fontSize: '14px',
    fontFamily: 'Sura Sans, system-ui',
  },
  checkIcon: {
    color: '#2D6DF6',
    fontSize: '24px'
  },
  cardInfoText: {
    fontSize: '16px',
    fontFamily: 'Sura Sans, system-ui',
  }
});

const ChangePaymentMethodAction = ({ 
  classes,
  row,
  paymentToken,
  clientToken,
  getRecurringPaymentInfo,
  paymentInfo,
  recurringPaymentRequestAgent,
  cancelRecurringPayment,
  currency,
  isLoading,
  dispatch,
  getAgentsPending,
  setShowCancellationMessage
  }) => {
  const location = useLocation();
  const isReceiptsPath = location.pathname === '/cobranza/recibos';
  
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [nestedPopoverAnchorEl, setNestedPopoverAnchorEl] = useState(null);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [reason, setReason] = useState('');
  const [isCancelling, setIsCancelling] = useState(false);
  const [activePaymentInfo, setActivePaymentInfo] = useState(null);

  if (!row) {
    return null;
  }

  const handleActivaClick = async (event) => {
    event.stopPropagation();
    setPopoverAnchorEl(event.currentTarget);
    
    // Si es ALEA, no necesitamos cargar información de pago
    if (row.gestor === "ALEA") {
      return;
    }
    
    setIsLoadingPayment(true);
    
    try {
      let uuidToUse;
      if (isReceiptsPath) {
        uuidToUse = row.receipts[0].uuid;
      } else {
        uuidToUse = row.uuid;
      }

      const tokenToUse = isReceiptsPath ? clientToken : paymentToken;
      const paymentInfo = await getRecurringPaymentInfo(tokenToUse, uuidToUse);
      setActivePaymentInfo(paymentInfo);
    } catch (error) {
      console.error('Error fetching payment info:', error);
    } finally {
      setIsLoadingPayment(false);
    }
  };

  const handlePopoverClose = () => {
    setPopoverAnchorEl(null);
    setNestedPopoverAnchorEl(null);
  };

  const handleOtherClick = (event) => {
    event.stopPropagation();
    setNestedPopoverAnchorEl(event.currentTarget);
  };

  const handleNestedPopoverClose = () => {
    setNestedPopoverAnchorEl(null);
  };

  const handleOptionClick = async (option, event) => {
    if (option === 'change') {
      if (event) {
        event.stopPropagation();
      }
      
      let uuidToUse;
      let totalToUse;
      let currencyToUse;

      if (isReceiptsPath) {
        uuidToUse = row.receipts[0].uuid;
        totalToUse = row.receipts[0].total;
        currencyToUse = row.receipts[0].currency;
      } else {
        uuidToUse = row.uuid;
        totalToUse = row.total;
        currencyToUse = row.currency;
      }

      const amount = Number(String(totalToUse).replace(/,/g, ''));
      const currencyRate = currencyToUse === 'USD' ? currency : 1;

      const tokenToUse = isReceiptsPath ? clientToken : paymentToken;

      const payload = {
        receipt: {
          uuid: uuidToUse,
          amount: amount,
          currency_rate: currencyRate
        },
        // Include token for backend to verify domiciliation permissions
        token: tokenToUse
      };
      
      await recurringPaymentRequestAgent(tokenToUse, payload);
    }
    
    handlePopoverClose();
    handleNestedPopoverClose();
  };

  const handleCancelClick = () => {
    setOpenCancelModal(true);
    handleNestedPopoverClose();
  };

  const handleCancelModalClose = () => {
    setOpenCancelModal(false);
    setReason('');
  };

  const handleAcceptCancel = async () => {
    if (!reason.trim()) {
      return;
    }

    setIsCancelling(true);
    try {
      if (!activePaymentInfo) {
        let uuidToUse;
        if (isReceiptsPath) {
          uuidToUse = row.receipts[0].uuid;
        } else {
          uuidToUse = row.uuid;
        }
        const paymentInfo = await getRecurringPaymentInfo(paymentToken, uuidToUse);
        setActivePaymentInfo(paymentInfo);
      }

      const activeCard = activePaymentInfo.data.find(card => card.status === 'ACTIVE');

      await cancelRecurringPayment(paymentToken, activeCard.uuid, reason);
      
      handlePopoverClose();
      handleNestedPopoverClose();
      handleCancelModalClose();
      setTimeout(() => {
        setShowCancellationMessage(true);
      }, 1000);
  
    } catch (error) {
      console.error('Error cancelling recurring payment:', error);
    } finally {
      setIsCancelling(false);
    }
  };

  const getPolicyInfo = () => {
    if (!row) return null;
    
    if (isReceiptsPath) {
      return {
        office_id: row.policy_details && row.policy_details.office_id ? row.policy_details.office_id : '',
        product_id: row.policy_details && row.policy_details.product_id ? row.policy_details.product_id : '',
        policy_id: row.policy_id || ''
      };
    }
    return {
      office_id: row.office_id || '',
      product_id: row.product_id || '',
      policy_id: row.policy_id || ''
    };
  };

  const policyInfo = getPolicyInfo();
  if (!policyInfo) return null;

  return (
    <Fragment>
      <Button
        className={classes.btnAqua}
        onClick={handleActivaClick}
      >
        {isReceiptsPath ? 'DOMICILIACIÓN ACTIVA' : 'ACTIVA'}
        <MoreVertIcon className={classes.menuButton} />
      </Button>
      <Popover
        open={Boolean(popoverAnchorEl)}
        anchorEl={popoverAnchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            zIndex: 1000,
            borderRadius: '14px',
          }
        }}
      >
        <div className={classes.popover}>
          <Typography className={classes.popoverTitle}>
            {row.gestor === "ALEA" 
              ? "Tu póliza está domiciliada con otro proveedor" 
              : "Método de pago seleccionado para realizar tu siguiente pago"
            }
          </Typography>
          <div className={classes.popoverContent}>
            {row.gestor === "ALEA" ? (
              <Typography className={classes.cardInfoText}>
                Si quieres administrar y actualizar tus métodos de pago desde este portal, cambia la domiciliación a <strong>OpenPay.</strong>
              </Typography>
            ) : (
              <Fragment>
                {isLoadingPayment ? (
                  <Typography className={classes.cardInfoText}>Cargando información...</Typography>
                ) : activePaymentInfo && activePaymentInfo.data && activePaymentInfo.data.length > 0 ? (
                  activePaymentInfo.data
                    .filter(card => card.status === 'ACTIVE')
                    .map((card, index) => (
                      <div key={index} className={classes.cardInfo}>
                        <CheckCircleIcon className={classes.checkIcon} />
                        <Typography className={classes.cardInfoText}>
                          {`Tarjeta de ${card.card_type === 'credit' ? 'crédito' : 'débito'} ****${card.card_reference}`}
                        </Typography>
                      </div>
                    ))
                ) : (
                  <Typography className={classes.cardInfoText}>No se encontró información de pago</Typography>
                )}
              </Fragment>
            )}
          </div>
          <Divider className={classes.popoverDivider} />
          <div className={classes.popoverButtons}>
            {row.gestor === "ALEA" ? (
              <Button
                className={classes.acceptButton}
                onClick={() => handleOptionClick('change')}
                style={{ width: '100%' }}
              >
                Cambiar domiciliación
              </Button>
            ) : (
              <Fragment>
                <Button
                  variant="outlined"
                  className={classes.otherButton}
                  onClick={handleOtherClick}
                >
                  Otro
                </Button>
                <Button
                  className={classes.acceptButton}
                  onClick={handlePopoverClose}
                >
                  Aceptar
                </Button>
              </Fragment>
            )}
          </div>
        </div>
      </Popover>
      <Popover
        open={Boolean(nestedPopoverAnchorEl)}
        anchorEl={nestedPopoverAnchorEl}
        onClose={handleNestedPopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            zIndex: 1001,
            borderRadius: '14px',
          }
        }}
      >
        <div className={classes.subPopover}>
          <button 
            className={classes.subMenuItem}
            onClick={(e) => handleOptionClick('change', e)}
            disabled={isLoading}
          >
            Cambiar método de pago
          </button>
          {!isReceiptsPath && (
            <Fragment>
              <Divider className={classes.popoverDivider} />
              <button 
                className={classes.subMenuItem}
                onClick={handleCancelClick}
              >
                Cancelar domiciliación
              </button>
            </Fragment>
          )}
        </div>
      </Popover>
      {!isReceiptsPath && (
        <Dialog
          open={openCancelModal}
          onClose={handleCancelModalClose}
          PaperProps={{
            style: {
              width: '418px',
              height: '598px',
              minHeight: '598px',
              maxWidth: '418px',
              margin: '16px',
              border: '0px solid',
              borderRadius: '24px',
              backgroundColor: '#FFFFFF'
            }
          }}
        >
          <DialogContent 
            className={classes.cancelContainer}
            style={{
              padding: '40px 30px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '20px',
              position: 'relative'
            }}
          >
            <IconButton
              onClick={handleCancelModalClose}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                color: '#0033A0'
              }}
            >
              <CloseIcon />
            </IconButton>
            <img src="/img/Calendar.webp" alt="Calendar" style={{ width: '65px', height: '65px' }} />
            <Typography className={classes.modalTitle}>
              Cancelar Domiciliación
            </Typography>
            <Typography className={classes.modalText}>
              ¿Estás seguro de que deseas cancelar la Domiciliación de esta póliza?
            </Typography>
            <Typography className={classes.policyNumber}>
              {policyInfo.office_id} - {policyInfo.product_id} - {policyInfo.policy_id}
            </Typography>
            <textarea
              className={classes.cancelReason}
              rows={4}
              placeholder="Ingresa el motivo de cancelación"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            <div className={classes.warningContainer}>
              <img src="/img/warningIconSura.svg" alt="Warning" className={classes.warningIcon} />
              <Typography className={classes.warningText}>
                Las póliza seleccionada tendrá que ser liquidada por otro medio de pago
              </Typography>
            </div>
            <Button
              className={classes.acceptButton}
              onClick={handleAcceptCancel}
              disabled={!reason.trim() || isCancelling}
            >
              {isCancelling ? 'Cancelando...' : 'Aceptar'}
            </Button>
          </DialogContent>
        </Dialog>
      )}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  paymentToken: state.agentReducer.paymentToken,
  clientToken: state.clientReducer.clientToken,
  paymentInfo: state.agentReducer.recurringPaymentInfo,
  currency: state.agentReducer.currency,
  isLoading: state.agentReducer.isLoading
});

const mapDispatchToProps = {
  getRecurringPaymentInfo,
  recurringPaymentRequestAgent,
  cancelRecurringPayment
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(ChangePaymentMethodAction); 


// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/changePaymentMethodAction.js